// components/ui/date-picker.jsx
import { useState } from 'react';
import { Button } from './button';
import { Calendar } from 'lucide-react';
import { format } from 'date-fns';
import { Calendar as CalendarComponent } from '../../components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../../components/ui/popover';

export function DatePicker({ date, onSelect }) {
  const [open, setOpen] = useState(false);

  const handleSelect = (range) => {
    if (range?.from) {
      onSelect(range);
      setOpen(false);
    }
  };

  const quickSelect = (days) => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - days);
    onSelect({ startDate: start, endDate: end });
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="w-[280px] justify-start text-left font-normal"
        >
          <Calendar className="mr-2 h-4 w-4" />
          {date.startDate ? (
            format(date.startDate, "LLL dd, y") + " - " + format(date.endDate, "LLL dd, y")
          ) : (
            <span>Pick a date</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <div className="p-4">
          <div className="grid grid-cols-2 gap-2 mb-4">
            <Button variant="outline" size="sm" onClick={() => quickSelect(7)}>Last 7 days</Button>
            <Button variant="outline" size="sm" onClick={() => quickSelect(30)}>Last 30 days</Button>
            <Button variant="outline" size="sm" onClick={() => quickSelect(90)}>Last 90 days</Button>
            <Button variant="outline" size="sm" onClick={() => quickSelect(365)}>Last year</Button>
          </div>
          <CalendarComponent
            mode="range"
            selected={{
              from: date.startDate,
              to: date.endDate
            }}
            onSelect={handleSelect}
            numberOfMonths={2}
          />
        </div>
      </PopoverContent>
    </Popover>
  );
}